import { useTranslation } from "react-i18next";
import { supabase } from "@/integrations/supabase/client";
import { usePeopleSearch } from "@/contexts/PeopleSearchContext";
import { ChipsInput } from "../ChipsInput";
import { TimeframeToggle } from "../TimeframeToggle";

// Typeahead over the experience concepts used by the organization
// (same source as AdvancedSearchPanel.tsx quick-add)
async function getTitleSuggestions(query: string): Promise<string[]> {
	// @ts-ignore - table exists but types not yet regenerated
	const { data, error } = await supabase
		.from('org_experiences')
		.select('name')
		.eq('category', 'role')
		.ilike('name', `%${query}%`)
		.limit(10);
	if (error) return [];
	// @ts-ignore - untyped rows from stale generated types
	return (data || []).map(row => row.name);
}

export function RolePanel() {
	const { t } = useTranslation();
	const { draft, updateDraft } = usePeopleSearch();

	return (
		<div className="space-y-4">
			<p className="text-sm text-muted-foreground">
				{t("peopleSearch.role.hint", "Candidates matching any of these job titles")}
			</p>
			<ChipsInput
				values={draft.role.titles}
				onChange={titles => updateDraft('role', { ...draft.role, titles })}
				placeholder={t("peopleSearch.role.placeholder", "Choose job titles")}
				getSuggestions={getTitleSuggestions}
			/>
			<TimeframeToggle
				value={draft.role.timeframe}
				onChange={timeframe => updateDraft('role', { ...draft.role, timeframe })}
			/>
		</div>
	);
}
